exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handle-in-time[data-v-334f3eb6] {\n  padding: 20px;\n  background-color: #edf4ff;\n  border-radius: 10px;\n}\n.handle-in-time .star[data-v-334f3eb6] {\n  width: 20px;\n  height: 20px;\n  margin-right: 10x;\n}\n.handle-in-time .list .list-item[data-v-334f3eb6] {\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  background-color: #fff;\n}\n.handle-in-time .list .list-item .rank-icon[data-v-334f3eb6] {\n  width: 20px;\n  height: 18px;\n  margin-right: 10px;\n}\n.handle-in-time .bottom-text[data-v-334f3eb6] {\n  line-height: 1.5;\n}\n", ""]);

// exports
